// Docs at https://tailwindcss.com/docs/configuration#referencing-in-java-script
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../../../tailwind.config.js'

// Usage `themeColor('green-500')` returns '#9ECB0A'
export const themeColor = (colorName) => {
  const tailwindTheme = resolveConfig(tailwindConfig).theme
  return tailwindTheme.colors[colorName]
}
